import styled from 'styled-components';

export const StructureContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const CertificateName = styled.div`
  display: flex;
  align-items: center;
`;
